import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import ImageUpload from "@/components/ImageUpload";

const EVENT_TYPES = ["conference", "workshop", "seminar", "meetup", "webinar", "summit", "other"];
const STATUSES = ["draft", "published", "live", "completed", "archived"];

export default function EventForm({ form, setForm }) {
  const set = (k) => (e) => setForm({ ...form, [k]: e?.target ? e.target.value : e });

  return (
    <div className="space-y-5">
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <Label className="mb-1.5 block">Event logo</Label>
          <ImageUpload value={form.logo} onChange={set("logo")} label="Logo" testid="event-logo" aspect="aspect-square" />
        </div>
        <div>
          <Label className="mb-1.5 block">Cover image</Label>
          <ImageUpload value={form.cover_image} onChange={set("cover_image")} label="Cover" testid="event-cover" aspect="aspect-square" />
        </div>
      </div>

      <div>
        <Label htmlFor="name">Event name</Label>
        <Input id="name" value={form.name} onChange={set("name")} required className="mt-1.5" placeholder="Africa Tech Forum 2026" data-testid="event-name" />
      </div>
      <div>
        <Label htmlFor="description">Description</Label>
        <Textarea id="description" value={form.description} onChange={set("description")} rows={3} className="mt-1.5" placeholder="What is this event about?" data-testid="event-description" />
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <Label>Event type</Label>
          <Select value={form.event_type} onValueChange={set("event_type")}>
            <SelectTrigger className="mt-1.5 capitalize" data-testid="event-type"><SelectValue /></SelectTrigger>
            <SelectContent>{EVENT_TYPES.map((t) => <SelectItem key={t} value={t} className="capitalize">{t}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div>
          <Label>Status</Label>
          <Select value={form.status} onValueChange={set("status")}>
            <SelectTrigger className="mt-1.5 capitalize" data-testid="event-status"><SelectValue /></SelectTrigger>
            <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s} className="capitalize">{s}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div><Label htmlFor="venue">Venue</Label><Input id="venue" value={form.venue} onChange={set("venue")} className="mt-1.5" placeholder="Sarit Expo Centre" data-testid="event-venue" /></div>
        <div><Label htmlFor="location">Location</Label><Input id="location" value={form.location} onChange={set("location")} className="mt-1.5" placeholder="Nairobi, Kenya" data-testid="event-location" /></div>
      </div>

      <div className="grid sm:grid-cols-3 gap-4">
        <div><Label htmlFor="date">Date</Label><Input id="date" type="date" value={form.date} onChange={set("date")} className="mt-1.5" data-testid="event-date" /></div>
        <div><Label htmlFor="start">Start time</Label><Input id="start" type="time" value={form.start_time} onChange={set("start_time")} className="mt-1.5" data-testid="event-start" /></div>
        <div><Label htmlFor="end">End time</Label><Input id="end" type="time" value={form.end_time} onChange={set("end_time")} className="mt-1.5" data-testid="event-end" /></div>
      </div>

      <div><Label htmlFor="contact">Contact information</Label><Input id="contact" value={form.contact_info} onChange={set("contact_info")} className="mt-1.5" placeholder="hello@yourorg.com" data-testid="event-contact" /></div>
    </div>
  );
}

export const emptyEvent = {
  name: "", description: "", logo: null, cover_image: null, event_type: "conference",
  status: "draft", venue: "", location: "", date: "", start_time: "", end_time: "", contact_info: "",
};
